import styled from "styled-components";

export const IfIsaPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 32px 0;
`;

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const ItemsCountContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;
